import { AxiosResponse } from 'axios';

export const downloadFile = ({ headers, data }: AxiosResponse, fileName: string) => {
  let name: string = fileName;
  if (headers) {
    const disposition = headers['content-disposition'] ?? '';
    const nameQuery = "filename*=UTF-8''";
    name = disposition?.length ? disposition.split(nameQuery)?.reverse()[0] ?? fileName : fileName;
  }
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name); //or any other extension
  document.body.appendChild(link);
  link.click();
};
